import { ReactNode } from 'react';
import styled from 'styled-components';

import { Snow } from '../Snow';

const Wrapper = styled.div`
  background-image: linear-gradient(
    to var(--gradient-direction, bottom),
    rgba(255, 43, 43, 0.2) 0%,
    rgba(16, 16, 16, 0.2) 100%
  );
  background-size: cover;
  background-color: var(--c-nd-50-opaque);

  position: relative;
  isolation: isolate;
  height: 100%;
`;

type Props = { children?: ReactNode } & React.JSX.IntrinsicElements['div'];

export const NeonChristmasBackground = ({ children, ...props }: Props) => {
  return (
    <Wrapper {...props}>
      <Snow />
      {children}
    </Wrapper>
  );
};
